// Non-component exports of the passenger search (house pattern: a sibling `.ts`
// module so `passenger-search.tsx` exports only components and keeps fast refresh).

/** Stable id so the topbar ⌘K handler can focus the input wherever it is mounted.
 *  Only one surface mounts it at a time (dashboard OR /passengers), so the id is
 *  unique in the document. The topbar keeps this value as a literal on purpose —
 *  the chrome does not import routes. */
export const PASSENGER_SEARCH_INPUT_ID = 'dashboard-search';

/** `2026-06-03T23:25:00Z` → `03 Jun 20:25` (locale-aware, no year). */
export function formatShortDateTime(iso: string | null | undefined): string | undefined {
  if (!iso) return undefined;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toLocaleDateString(undefined, {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}
